import { fromEvent, Observable } from 'rxjs';
import { AxDatePicker, Cell, Mode } from '../../Components/AxDatepicker/AxDatepicker';
import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { RequestHelper } from '../../Lib/Helper/RequestHelper';
import { AxProgressBar, Step } from "../../Limestone/AxProgressBar/AxProgressBar";
import { ProgressBar, ProgressBarMode } from "../Global/Progressbar";
import Swal, { SweetAlertOptions } from 'sweetalert2';
import { AxAlertBanner as AxMessage } from "../../Limestone/AxMessage/AxAlertBanner";
import { I18nHelper, Translations } from '../../Lib/Helper/I18nHelper';
import { TimeSlotKey } from "../../Models/Reservation/TimeSlotKey";
import { AxDropdown, IAxDropdownOptions } from "@axess/limestone";


@ModuleName("TimeSlots")
export class TimeSlots implements AxInit {
    private InitData: TimeSlotInitData;

    public ProjectNr: number;
    public PosNr: number;
    public SerialNr: number;

    protected DatePicker: AxDatePicker;
    protected DatePickerMobile: AxDatePicker;
    protected DatePattern: string;

    protected DateDropdown: AxDropdown = new AxDropdown();
    protected selectedTimeSlots: TimeSlotKey[] = [];

    protected btnSubmit = document.getElementById('goNext') as HTMLButtonElement;

    protected AxMessage: AxMessage = new AxMessage();

    constructor(private _Progressbar = new ProgressBar(),
        private _AxProgressBar = new AxProgressBar,
        protected _RequestHelper = new RequestHelper(),
        private _i18nHelper = new I18nHelper) { }


    AxInit(init: TimeSlotInitData): void {
        this.InitData = init;
        this.DatePicker = new AxDatePicker();
        this.DatePickerMobile = new AxDatePicker();
        let sts: Step[] = this._Progressbar.GetReservationSteps();

        $(document).on("click", "button.ax-chip", (e) => {
            this.SelectionContingent(e.currentTarget);
        });

        this.btnSubmit.disabled = true;

        this.btnSubmit.addEventListener('click', (e: Event) => this.SaveData());

        this.DatePattern = this.InitData.DatePatternYear;
        
        this.DateDropdown.init(`#date_out`,
            {
                searchBar: false,
                multiSelect: false
            });

        this.DatePicker.Init({
            StartOfWeek: this.InitData.StartOfWeek,
            Lang: this.InitData.Lang,
            StartDate: moment(this.InitData.StartDate, "YYYY-MM-DD"),
            Target: '#tariff_date',
            Mode: Mode.Inline,
            EndDate: moment(this.InitData.EndDate, "YYYY-MM-DD"),
            BlockedDates: null,
            AvailableDates: null
        });

        this.DatePickerMobile.Init({
            StartOfWeek: this.InitData.StartOfWeek,
            Lang: this.InitData.Lang,
            StartDate: moment(this.InitData.StartDate, "YYYY-MM-DD"),
            Target: '#tariff_date_mobile',
            Mode: Mode.Endless,
            EndDate: moment(this.InitData.EndDate, "YYYY-MM-DD")
        });

        this.DatePicker.ActivationSubject.subscribe(x => this.CheckDate(x));
        this.DatePickerMobile.ActivationSubject.subscribe(x => this.CheckDate(x));

        let ddlDate$: Observable<MouseEvent>;

        ddlDate$ = fromEvent<MouseEvent>(document.getElementById("date_out"), 'click');
        
        ddlDate$
            .subscribe((sp) => {
                let $calendar = $("#testni_div");
                $calendar.toggleClass('d-none');

                let $calendar2 = $("#testni_div2");
                $calendar2.toggleClass('d-none');
            });
    }

    CheckDate(x: Cell) {
        if (x != null) {
            let $calendar = $("#testni_div");
            $calendar.addClass('d-none');

            let $calendar2 = $("#testni_div2");
            $calendar2.addClass('d-none');



            this.ClearSelectedContigents();


            let formatedDate = x.Date.format(this.DatePattern);
            let $slot_div = $('.product_selection__allotment_selection');
            $slot_div.addClass('ax-loading');

            this.DateDropdown.setValue(formatedDate);

            AxessViewer.loadPartialView('/Reservations/_LoadContigents', { projNr: this.InitData.ProjNr, posNr: this.InitData.PosNr, serialNr: this.InitData.SerialNr, date: formatedDate }, (resp) => {
                $slot_div.html(resp.view);
                $slot_div.removeClass('ax-loading');
            }, {});
        }
    }

    SelectionContingent(e: Element): void {
        let $elem: JQuery<Element> = $(e);
        let color: string = 'green';

        const timeSlotGroupKey: number = parseInt($elem.data('timeslotgroupkey'));
        const timeSlotKey1 = $elem.data('timeslotkey1');
        const timeSlotKey2: number = parseInt($elem.data('timeslotkey2'));

        const timeSlotKey: TimeSlotKey = new TimeSlotKey(timeSlotGroupKey, timeSlotKey1, timeSlotKey2);

        for (let timeSlot of this.selectedTimeSlots.filter(x => x.timeSlotGroupKey === timeSlotGroupKey)) {
            let $tmpButton = $(`.product_selection__allotment_selection button[data-timeSlotGroupKey="${timeSlot.timeSlotGroupKey}"][data-timeSlotKey1="${timeSlot.timeSlotKey1}"][data-timeSlotKey2="${timeSlot.timeSlotKey2}"]`);
            let tmpColor: string = $tmpButton.attr('data-contingentstatus');
            $tmpButton.removeClass(`ax-fill-${tmpColor}-500`).addClass(`ax-outline-${tmpColor}-500`);
        }

        let index: number = this.selectedTimeSlots.findIndex(x => x.timeSlotGroupKey === timeSlotGroupKey);
        if (index > -1) {
            this.selectedTimeSlots.splice(index, 1);
        }

        this.selectedTimeSlots.push(timeSlotKey);
        $elem.removeClass(`ax-outline-${color}-500`).addClass(`ax-fill-${color}-500`);
        this.CheckSelection();
    }

    deactivateContingent(timeSlotKey: TimeSlotKey) {
        let index: number = this.selectedTimeSlots.findIndex(x => x.equal(timeSlotKey));
        if (index > -1) {
            this.selectedTimeSlots.splice(index, 1);
        }

        $(`.product_selection__allotment_selection button[data-timeSlotGroupKey="${timeSlotKey.timeSlotGroupKey}"][data-timeSlotKey1="${timeSlotKey.timeSlotKey1}"][data-timeSlotKey2="${timeSlotKey.timeSlotKey2}"]`).each((i, tmpButton) => {
            let $tmpButton: JQuery<Element> = $(tmpButton);
            let tmpColor: string = $tmpButton.attr('data-contingentstatus');
            $tmpButton.removeClass(`ax-fill-${tmpColor}-500`);
        });
    }

    CheckSelection() {
        let contains = true;
        let that = this;

        if (that.selectedTimeSlots.length > 0) {
            contains = true;
        }
        else {
            contains = false;
        }

        if (contains) {
            this.btnSubmit.disabled = false;
        } else {
            this.btnSubmit.disabled = true;
        }
    }

    ClearSelectedContigents(): void {
        this.selectedTimeSlots = [];
    }

    SaveData(): void {
        let tmp = [];

        for (let timeSlot of this.selectedTimeSlots) {
            tmp.push({
                timeSlotGroupKey: timeSlot.timeSlotGroupKey,
                timeSlotKey1: timeSlot.timeSlotKey1.toString(),
                timeSlotKey2: timeSlot.timeSlotKey2
            });
        }

        if (this.selectedTimeSlots.length === 1) {
            Swal.fire({
                title: this._i18nHelper.GetTranslation(Translations.AreYouSure),
                text: this._i18nHelper.GetTranslation(Translations.OneWayReservation),

                showCancelButton: true,

                confirmButtonText: this._i18nHelper.GetTranslation(Translations.ConfirmReservation)
            } as SweetAlertOptions).then((result) => {
                if (result.value) {

                    let data = {
                        projNr: this.InitData.ProjNr,
                        posNr: this.InitData.PosNr,
                        serialNr: this.InitData.SerialNr,
                        timeSlots: tmp,
                        timeSlotToDelete: this.InitData.DateToDelete
                    }

                    AxessViewer.loadPartialView('/Reservations/SaveReservation', data, (resp) => {
                        this._RequestHelper.postToUrl('Reserved', { projNr: this.InitData.ProjNr, posNr: this.InitData.PosNr, serialNr: this.InitData.SerialNr, message: resp.message, message_type: resp.success }, {});
                    }, { silent: true });
                }
            });
        }
        else {
            AxessViewer.loadPartialView('/Reservations/SaveReservation',
                {
                    projNr: this.InitData.ProjNr,
                    posNr: this.InitData.PosNr,
                    serialNr: this.InitData.SerialNr,
                    timeSlots: tmp,
                    timeSlotToDelete: this.InitData.DateToDelete
                }, (resp) => {
                    this._RequestHelper.postToUrl('Reserved', { projNr: this.InitData.ProjNr, posNr: this.InitData.PosNr, serialNr: this.InitData.SerialNr, message: resp.message, message_type: resp.success }, {});
                }, { silent: true });
        }
    }
}


interface TimeSlotInitData {
    ProgressBarMode: ProgressBarMode;
    Progress: number;
    DatePatternYear: string;
    StartOfWeek: number;
    Lang: string;
    StartDate: string;
    EndDate?: string;
    ProjNr: number;
    PosNr: number;
    SerialNr: number;
    DateToDelete: string;
}
